__turbopack_context__.v({
  "default": "DiscoveryButton-module__xl3u2W__default",
  "disabled": "DiscoveryButton-module__xl3u2W__disabled",
  "icon": "DiscoveryButton-module__xl3u2W__icon",
  "label": "DiscoveryButton-module__xl3u2W__label",
  "link": "DiscoveryButton-module__xl3u2W__link",
  "root": "DiscoveryButton-module__xl3u2W__root",
  "secondary": "DiscoveryButton-module__xl3u2W__secondary",
});
